export default __webpack_public_path__ + "static/media/alertes-3.e88a7210.png";